import { Box, GlobalStyles, MAIN_CONTENT_ID, SkipLink } from '@munifocus/ui';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';

export function SiteLayout({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'clip',
        maxWidth: '100%',
      }}
    >
      <GlobalStyles
        styles={{
          '@keyframes mf-fadeUp': {
            from: { opacity: 0, transform: 'translateY(18px)' },
            to: { opacity: 1, transform: 'translateY(0)' },
          },
          '@media (prefers-reduced-motion: reduce)': {
            '*': {
              animation: 'none !important',
              transition: 'none !important',
            },
          },
        }}
      />
      <SkipLink label={t('common.a11y.skipToContent')} />
      <SiteHeader />
      <Box component="main" id={MAIN_CONTENT_ID} tabIndex={-1} sx={{ flex: 1 }}>
        {children}
      </Box>
      <SiteFooter />
    </Box>
  );
}

export const fadeUp = (delaySec = 0) => ({
  animation: `mf-fadeUp 0.55s cubic-bezier(0.2, 0.7, 0.2, 1) ${delaySec}s both`,
});
